import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import MetisMenu from 'metismenu';

export const initializeApp  = () => {

    const appContainer = document.querySelector('.app-container');
    if (appContainer) {
        new PerfectScrollbar(appContainer);
    }
    const headerMessage = document.querySelector('.header-message-list');
    if (headerMessage) {
        new PerfectScrollbar(headerMessage);
    }
    const headerNotification = document.querySelector('.header-notifications-list');
    if (headerNotification) {
        new PerfectScrollbar(headerNotification);
    }

    document.querySelector('.mobile-search-icon')?.addEventListener('click', () => {
        document.querySelector('.search-bar')?.classList.add('full-search-bar');
    });

    document.querySelector(".search-close")?.addEventListener("click", () => {
        document.querySelector(".search-bar")?.classList.remove("full-search-bar");
    });

    // Menu mobile
    document.querySelector(".mobile-toggle-menu")?.addEventListener("click", () => {
        document.querySelector(".wrapper")?.classList.add("toggled");
    });

    document.addEventListener('DOMContentLoaded', function() {
        let currentUrl = window.location.href;
        let menuLinks = document.querySelectorAll('.metismenu li a');

        menuLinks.forEach(function(link) {
            if (link.href === currentUrl) {
                link.classList.add("");
                let parentLi = link.parentElement;
                parentLi.classList.add("mm-active");

                let parent = parentLi;
                while (parent && parent.tagName.toLowerCase() === "li") {
                    parent = parent.parentElement;
                    if (parent) {
                        parent.classList.add("mm-show");
                        parent.classList.add("mm-active");
                    }
                }
            }
        });

        if (typeof MetisMenu !== 'undefined') {
            let menu = document.getElementById("menu");
            if (menu) {
                new MetisMenu(menu);
            }
        }
    });

    const backToTop = document.querySelector(".back-to-top");
    if (backToTop) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 300) {
                backToTop.classList.add("visible");
                backToTop.style.display = 'block';
            } else {
                backToTop.classList.remove("visible");
                backToTop.style.display = 'none';
            }
        });

        backToTop.addEventListener("click", (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
        });
    }
}